'use client'

import { FunctionComponent } from 'react'
import useSetProductOnRecentViewedProducts from '../../../core/hook/useSetProductOnRecentViewedProducts'

type ProductEventProps = {
  product: Product
}
const ProductEvent: FunctionComponent<ProductEventProps> = ({ product }) => {
  useSetProductOnRecentViewedProducts(product)

  return null
}

export default ProductEvent
